import Dict from '@/utils/dict-utils'

/**
 * 框架协议来源
 * @property {1} ADD 新增框架协议
 * @property {2} SOURCE 寻源结果
 */
export const purchaseFrameAgreementSourceTypeDict = new Dict({
  ADD: { value: 0, label: '新增', type: 'primary' },
  IMPORT: { value: 1, label: '导入', type: 'primary' }
})

/**
 * 框架协议状态
 * @property {1} EDITING 编辑中
 */
export const purchaseFrameAgreementStatusDict = new Dict({
  EDITING: {
    value: 0,
    label: '编辑中',
    type: 'primary',
    permissions: ['edit', 'delete']
  },
  INIT: {
    label: '待提交审批',
    value: 1,
    type: 'info',
    permissions: ['detail']
  },
  TO_AUDIT: {
    label: '审批中',
    value: 2,
    type: 'primary',
    permissions: ['detail']
  },
  WITHDRAWER: {
    label: '已撤回',
    value: 3,
    type: 'warning',
    permissions: ['edit']
  },
  // PASS: {
  //   label: '审核通过',
  //   value: 4,
  //   type: 'success',
  //   permissions: ['detail']
  // },
  REJECT: {
    label: '审批不通过',
    value: 5,
    type: 'danger',
    permissions: ['edit', 'delete', 'detail']
  },
  UN_VALIDITY: {
    value: 6,
    label: '未生效',
    type: 'success',
    permissions: ['detail']
  },
  VALIDITY: {
    value: 7,
    label: '有效期内',
    type: 'success',
    permissions: ['detail']
  },
  EXPIRED: {
    value: 8,
    label: '已失效',
    type: 'danger',
    permissions: ['detail']
  }
})

/**
 * 料号
 */
export const purchaseLiaoHaoTypeDict = new Dict({
  Z: { value: 1, label: 'Z' },
  P: { value: 2, label: 'P' },
  Q: { value: 3, label: 'Q' },
  K: { value: 4, label: 'K' }
})
